import script from "./Vehicle.vue?vue&type=script&setup=true&lang=js"
export * from "./Vehicle.vue?vue&type=script&setup=true&lang=js"

import "./Vehicle.vue?vue&type=style&index=0&id=492524ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492524ca"]])

export default __exports__